"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onLoadedData;
function onLoadedData(event) {
  if (this.live) {
    this._liveStatusPollTimeout = setTimeout(this._pollLiveStreamAttributes.bind(this), 0);
  }
  this.emit('loadeddata', event);
}